import React, { createContext, useState } from 'react'
import { appConfig } from 'config'

export type ConfigContextProps = Record<string, any>

export const ConfigContext = createContext<ConfigContextProps>({})

export const ConfigProvider: React.FC = ({ children }) => {
  const [config, setConfig] = useState<ConfigContextProps>(appConfig)

  return (
    <ConfigContext.Provider value={{ config, setConfig }}>
      {children}
    </ConfigContext.Provider>
  )
}
